/**
 * 任务类型、子任务「任务角色」中文标签（与种子数据 crm_task / crm_task_user 等枚举对齐）。
 * 勿将「任务类型」与「任务角色」混用。
 */
export const TASK_TYPE_OPTIONS: { key: string; name: string }[] = [
  { key: 'development', name: '开发实施' },
  { key: 'training', name: '培训授课' },
  { key: 'assessment', name: '人才测评' },
  { key: 'workshop', name: '研讨催化' },
  { key: 'interview', name: '调研访谈' },
  { key: 'research', name: '需求调研' },
  { key: 'document', name: '文档方案' },
  { key: 'contract', name: '合同签订' },
  { key: 'consulting', name: '咨询服务' },
  { key: 'consulting_delivery', name: '咨询交付' },
  { key: 'online', name: '线上辅导' },
  { key: 'teaching_assistant', name: '助教服务' },
  { key: 'visual_recording', name: '视觉记录' },
  { key: 'call', name: '电话沟通' },
  { key: 'email', name: '邮件往来' },
  { key: 'meeting', name: '会议' },
  { key: 'visit', name: '拜访' },
  { key: 'other', name: '其他' },
];

/** 子任务行「任务角色」：与 role_type 存储值对齐 */
export const TASK_ROLE_OPTIONS: { key: string; name: string }[] = [
  { key: 'executor', name: '执行人' },
  { key: 'reviewer', name: '复核人' },
  { key: 'owner', name: '负责人' },
  { key: 'assistant', name: '协助人' },
  { key: 'participant', name: '参与人' },
  { key: 'observer', name: '观摩人' },
  { key: 'other', name: '其他' },
];

export function labelTaskType(type: string | undefined): string {
  if (!type) return '';
  return TASK_TYPE_OPTIONS.find((t) => t.key === type)?.name ?? type;
}

export function labelTaskRole(role: string | undefined): string {
  if (!role) return '';
  return TASK_ROLE_OPTIONS.find((r) => r.key === role)?.name ?? role;
}
